import { graphql, useStaticQuery } from "gatsby"

type ContentfulEntry = {
  entries: {
    nodes: {
      id: string
      contentful_id: string
      slug?: string
      node_locale?: string
    }[]
  }
}
export const useContentfulEntry = (entryID: string) => {
  const { entries }: ContentfulEntry = useStaticQuery(graphql`
    query slugQuery($locale: String) {
      entries: allContentfulEntry(filter: { node_locale: { eq: $locale } }) {
        nodes {
          contentful_id
          id
          node_locale

          ... on ContentfulPageFeedbackPayment {
            contentful_id
            node_locale
            slug
          }

          ... on ContentfulLandingPageEdControls {
            contentful_id
            node_locale
            slug
          }

          ... on ContentfulContentPageNewEdcHomePage {
            contentful_id
            slug
            node_locale
          }

          ... on ContentfulEdc22ContentPageImportedEdControlsPages {
            id
            contentful_id
            slug
          }
          ... on ContentfulContentBlockDetailsForm {
            contentful_id
            node_locale
          }
          ... on ContentfulContentBlockConfirmationBlock {
            contentful_id
            node_locale
          }
          ... on ContentfulEdc22ContentPagePricingPage {
            contentful_id
            slug
            node_locale
          }
          ... on ContentfulEdc22ContentBlockLicenseBlock {
            contentful_id
            node_locale
          }
          ... on ContentfulEdc22ContentPageContactDemoForm {
            contentful_id
            node_locale
            slug
          }
          ... on ContentfulPageAccountDetail {
            contentful_id
            node_locale
            slug
          }
          ... on ContentfulEdc22OverviewPageCasesAndReferences {
            slug
            node_locale
            contentful_id
          }
          ... on ContentfulEdc22ContentBlockImageAndTextLink {
            contentful_id
            node_locale
          }
          ... on ContentfulEdc22ContentBlockRequestDemo {
            contentful_id
            node_locale
          }
          ... on ContentfulEdc22ContentBlockEdCCommercialHeader {
            contentful_id
            node_locale
          }
          ... on ContentfulEdc22ContentBlockFooter {
            contentful_id
            node_locale
          }

          ... on ContentfulPageContentModel {
            slug
            node_locale
            contentful_id
          }
          ... on ContentfulContentBlockJumpLinkComponent {
            contentful_id
            internal {
              type
            }
            identifier
          }
          ... on ContentfulEdc22ContentBlockButton {
            buttonColor
            buttonText
            buttonTitle
            buttonUrl
            contentful_id
            node_locale
          }
          ... on ContentfulLandingPageEdControls {
          id
            contentful_id
            slug
            node_locale
          }
          ... on ContentfulContentPageFaqPage {
            id
            contentful_id
            slug
            node_locale
          }
        }
      }
    }
  `)

  const entry = entries.nodes.find(
    node =>
      node.contentful_id === entryID &&
      node.node_locale === process.env.language,
  )
  if (entry === undefined) {
    return "/404"
  }
  if (entry.slug === "new-home-page") {
    return ""
  } else {
    return entry.slug
  }
}
